import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, interval, startWith } from 'rxjs';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  private updateCheckSubscription?: Subscription;
  private versionUpdatesSubscription?: Subscription;
  private isInitialized = false;

  constructor(private swUpdate: SwUpdate) {

  }

  checkForUpdates() {
    // Prevent multiple initializations
    if (this.isInitialized) {
      console.log('Update service already initialized - skipping');
      return;
    }

    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker not enabled');
      return;
    }

    this.isInitialized = true;
    console.log('Initializing update service');

    this.startUpdateChecks();

    // Listen for available updates
    this.versionUpdatesSubscription = this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe((evt) => {
        console.log('New version available');
        if (confirm('New version available. We recommend to reload the application to get the latest updates. Reload now?')) {
          window.location.reload();
        }
      });
  }
  

  private startUpdateChecks() {
    // Check immediately, then every 60 seconds
    this.updateCheckSubscription = interval(60000).pipe(
      startWith(10000) // Emit immediately, then every 60 seconds
    ).subscribe(() => {
      const timestamp = new Date().toISOString();
      console.log(`[${timestamp}] Checking for updates...`);
      
      this.swUpdate.checkForUpdate().then((updateFound) => {
        console.log(`[${timestamp}] Update check complete`);
      }).catch(err => {
        console.log(`[${timestamp}] Error checking for updates`);
      });
    });
  }

  // Optional: method to manually stop checks (for testing)
  stopChecks() {
    this.updateCheckSubscription?.unsubscribe();
    this.versionUpdatesSubscription?.unsubscribe();
    this.isInitialized = false;
  }
}